<!-- 公共底部 -->
<template>
  <div class="footer">
     <div class="links hidden-sm-and-down">
        <a href="https://www.monetware.com/about-us/" target="_blank">关于我们</a>
        <a href="https://www.ringdata.com/user_agreement" target="_blank">服务协议</a>
        <a href="https://www.ringdata.com/privacy_policy" target="_blank">隐私政策</a>
      </div>
      <div class="copyright">Copyright © 2019 上海萌泰数据科技股份有限公司 ©版权所有.<a href=" http://beian.miit.gov.cn" target="_blank" style="color:#206184;">沪ICP备09099644号</a></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    // 隐私政策
    goPrivacy (key) {
      this.$router.push({
        path: '/privacy',
        query: {
          key: key
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// 底部
  .footer {
    width: 100%;
    height: 50px;
    padding: 5px 0;
    background-color: #eaeaea;
    text-align: center;
    .links {
      text-align: center;
      a {
        color: #010101;
        font-size: 13px;
        text-decoration: none;
      }
      a ~ a {
        margin-left: 15px;
      }
    }
    .copyright {
      text-align: center;
      font-size: 11px;
      padding: 3px 0px 0px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue